// eslint-disable-next-line
import { injectable } from "inversify";
import { IApiResponse, IHttpService } from "../http-service";
import { TYPE, rootContainer } from "../container/root";

export interface IRMACounter {
    name: string,
    link: string,
    count: number
}

export interface INotValidatedOwnerData {
    message: string;
}

@injectable()
class DashboardService {
    private readonly httpService: IHttpService = rootContainer.get<IHttpService>(TYPE.ApiHttp);

    public async fetchRMACounters(): Promise<IRMACounter[]> {
        const res = await this.httpService.get<IApiResponse<IRMACounter[]>>(`/rms-api/rma-counters`);
        return res.payload;
    }

    public async fetchNotVerifiedOwnerData(): Promise<INotValidatedOwnerData> {
        const res = await this.httpService.get<IApiResponse<INotValidatedOwnerData>>(`/rms-api/not-verified-owner-data`);
        return res.payload;
    }
}

export default DashboardService;
